import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressDelegation extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressDelegation
